import Modal from '@/components/modals/modal/modal.vue';
import { mapActions } from 'vuex';

export default {
  name: 'ShowTMCModal',
  components: {
    Modal,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    modalError: {
      type: Boolean,
      default: false,
    },
    courierId: {
      type: Number,
      required: true, // или используйте default если не хотите, чтобы это был обязательный параметр
    },
  },
  methods: {
    async fetchCourierInventory() {
      try {
        const inventoryData = await this.getCourierInventory(this.courierId);
        this.inventory = inventoryData;
      } catch (error) {
        this.error = error;
        console.error('Ошибка при получении инвентаря курьера:', error);
      }
    },

    async show() {
      await this.fetchCourierInventory();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    ...mapActions({
      getCourierInventory: 'couriers/getCourierInventory',
    }),

    mounted() {
      // Загружаем инвентарь при монтировании компонента
      this.loadInventory();
    },
  },
  data() {
    return {
      inventory: null, // Для хранения инвентаря курьера
      error: null, // Для хранения возможных ошибок
    };
  },
};
